import { konsole } from './util';

export default class TemplateParser {
  /* Tim
    * @original author: Premasagar Rose / github.com/premasagar/tim
    * @license: MIT license
  */
  constructor(delimiterStarts, delimiterEnds) {
    this.pattern = new RegExp((
      (delimiterStarts || "{{") +
        "\\s*([a-z0-9_$][\\.a-z0-9_]*)\\s*" +
      (delimiterEnds || "}}")
    ), "gi");
  }

  createRenderer(setup) {
    return ((that, o) => (_tpl, _data) => that.parse(
      _tpl || o.template || '', _data || o.data || {}, o.id, o.context
    ))(this, setup);
  }

  parse(template, data, _id, _ctx, _except) {
    const that = this;
    const _errorPre = `tim [${_id || 'n/a'}]: `;
    _ctx = _ctx || data;
    if (typeof template === "function") {
      template = template.call(_ctx, data);
    }
    if (typeof template !== 'string') {
      konsole.log(_errorPre + 'invalid template]', template);
      return null;
    }

    return template.replace(that.pattern, (tag, token) => {
      const path = token.split(".");
      const l = path.length;
      let part = data;
      let i = 0;

      for (; i < l; i++) {
        if (!part) { continue; }
        part = part[path[i]];

        if (typeof part === "undefined") {
          konsole.log(
            `${_errorPre}${tag} "${path[i]}" is not in the supplied data`, data
          );
        }
        else if (i === l - 1) {
          part = typeof part === 'function' ? part.call(_ctx) : part;
          if (that.pattern.test(part + '') && part !== _except) {
            // _except: to avoid possible out of range exceptions
            return that.parse(part, data, _id, _ctx, part);
          }

          return part;
        }
      }
      return '';
    });
  }
}
